import { Component, computed, effect, input, output } from '@angular/core';
import { KopConfigService } from '../../core/kop-config.service';
import { JSBridgeService } from '../../core/jsbridge.service';
import { KopModulesService } from '../../modules/kop-modules.service';
import { wasmVectorToArray } from '../../utils/wasmVector';

@Component({
  selector: 'global-alarm-texts',
  templateUrl: './global-alarm-texts.component.html',
  styles: `
  .alarm-wrapper {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    max-height: 480px;
    column-gap: 5px;
  }`
})
export class GlobalAlarmTextsComponent {

  constructor(public kopConfigService: KopConfigService, public jsBridgeService: JSBridgeService,
    public kopModulesService: KopModulesService) {
    for (let i = 0; i < 20; i++) {
      this.range.push(i);
    }
    effect(() => {
      if (this.isEditing()) {
        this.editVal = {};
        let alarmTexts = this.alarmTexts();
        for (let i of this.range) {
          if (alarmTexts[i] != undefined) {
            this.editVal[i] = alarmTexts[i];
          } else {
            this.editVal[i] = "";
          }
        }
      }
    });
  }

  public alarmTexts = computed(() => {
    let kopConfig = this.jsBridgeService.kopConfig();
    let ret: Record<number, string> = [];
    if (kopConfig != undefined) {
      let tmATs = kopConfig.gAlarmTeksten;
      if (tmATs != undefined) {
        let keys = wasmVectorToArray(tmATs.keys());
        keys.forEach(key => {
          let text = tmATs.get(key);
          if (text != undefined) {
            ret[key] = text?.toString();
          }
        });
      }
    }
    return ret;
  });

  public isEditing = input<boolean>(false);
  public onDone = output<boolean>();
  public editVal: Record<number, string> = {};
  public range: Array<number> = [];

  public edit() {
  }

  public onSave() {
    this.jsBridgeService.kopConfig.update(kfg => {
      if (kfg != undefined) {
        for (let [key, val] of Object.entries(this.editVal)) {
          let iKey = parseInt(key);
          if (val != "") {
            kfg.gAlarmTeksten.set(parseInt(key), val);
          } else if (kfg.gAlarmTeksten.get(iKey) != undefined) {
            kfg.gAlarmTeksten.erase(iKey);
          }
        }
      }
      return kfg;
    });
    this.onDone.emit(true);
    this.kopConfigService.isDirty.set(true);
  }

}
